import TfwTrainIcon from './TfwTrainIcon';

export default TfwTrainIcon;